export const CZJS = {
    wizard: {
        selectDate:
            'Select your move in date',
        insuranceCoverage: {
            title: 'Protection Coverage',
            pickerText: 'Maximum Replacement Value of ',
        },
        bookingConfirmation: {
            subtitle:
                'You will shortly receive 2 emails, the first will contain a receipt of your purchase and further instructions on your move in process. The second will contain a link that will allow you to register for the Squab Storage app where you will be able to complete the ID verification process to complete your sign-up',
        },
    },
    contact_card: {
        move_in_date:
            'Select your move in date',
    },
};
